import { memo, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "helpers";
import { Button } from "ui/components/Button/Button";
import { Dialog } from "ui/components/Dialog";
import { deleteFleetVehicleAPI } from "services/api/fleet/vehicles/api";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";

interface VehicleDeleteActionProps {
  vehicleId: string;
}

const VehicleDeleteAction: React.FC<VehicleDeleteActionProps> = ({ vehicleId }) => {
  const navigate = useNavigate();
  const { t } = useTranslate();

  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);

  const handleDeleteClick = useCallback(() => {
    setOpenDeleteDialog(true);
  }, []);

  const handleDeleteDialogConfirm = useCallback(async () => {
    if (!vehicleId) return;

    try {
      const deleted = await deleteFleetVehicleAPI(vehicleId, t);

      if (deleted) {
        navigate(FleetVehicleRoutes.FleetVehicleSearchPageRouter);
      }

      setOpenDeleteDialog(false);
    } catch (err) {
      console.error("Greška prilikom brisanja vozila:", err);
    }
  }, [vehicleId, t, navigate]);

  const handleDeleteDialogClose = useCallback(() => {
    setOpenDeleteDialog(false);
  }, []);

  return (
    <>
      <Button
        variant="remove"
        children={t("admin.delete")}
        onClick={handleDeleteClick}
        startIcon="/media/icons/trash.svg"
      />
      <Dialog
        open={openDeleteDialog}
        title={t("admin.fleet.vehicle.dialog.delete.title")}
        message={t("admin.fleet.vehicle.dialog.delete.message")}
        confirmText={t("admin.fleet.vehicle.dialog.delete.confirmtext")}
        cancelText={t("admin.fleet.vehicle.dialog.delete.canceltext")}
        onConfirm={handleDeleteDialogConfirm}
        onCancel={handleDeleteDialogClose}
      />
    </>
  );
};

export default memo(VehicleDeleteAction);
